import React, { useState, memo } from 'react';
import { toPrice } from '@/utils/price';
import * as seatUtil from '@/utils/seat';
import useTimeout from '../../hooks/useTimeout';
import styles from '../../style/index.less';
import { TLang } from '@/utils/lang';
import DFDiscount from '@/components/dfDiscount';
const close = require('../SiteList/images/close.png');
interface IMulPriceProps {
  sortPrices: Array<any>;
  activeColor: number;
  onClick: (i: number) => void;
  unionConfig?: any;
  lowPriceTag?: boolean;
}

const MulPriceArea = (props: IMulPriceProps) => {
  const { sortPrices, activeColor, onClick, unionConfig, lowPriceTag } = props;
  // 多票价提示
  const [showTips, setShowTips] = useState(true);
  const closeTipHandle = () => {
    setShowTips(false);
  };
  useTimeout(() => {
    setShowTips(false);
  }, 5000);
  return (
    <div className={styles.priceAndTips}>
      <ul className={styles.multiPriceWrapper}>
        {sortPrices.map((item, index) => {
          let maxLen = seatUtil.multiPriceColor.length - 1;
          let colorObj =
            index >= maxLen ? seatUtil.multiPriceColor[maxLen] : seatUtil.multiPriceColor[index];
          let cls =
            activeColor == index
              ? {
                color: colorObj.color,
                backgroundColor: colorObj.bgColor,
                border: `2px solid ${colorObj.color}`
              }
              : {
                color: colorObj.color,
                backgroundColor: colorObj.bgColor,
                border: `2px solid ${colorObj.bgColor}`
              };
          return (
            <li style={cls} onClick={() => onClick(index)} key={index}>
              {' '}
              <b className={styles.dot} style={{ borderColor: colorObj.color }} />{' '}
              {unionConfig ? ((item / 100) * unionConfig.union_scale).toFixed(2) : toPrice(item)}
              {/* {lowPriceTag ? <DFDiscount style={{top: "-0.02rem"}}/> : null} */}
            </li>
          );
        })}
      </ul>
      {unionConfig ? (
        <div className={styles.priceUnit}>{`${TLang('票价单位为', 'home', false, false, null)}${unionConfig.union_name || TLang('福豆', 'home', false, false, null)}`}</div>
      ) : null}
      {showTips ? (
        <div className={styles.multiPriceTipsWrapper}>
          <div className={styles.tipsWrapper}>
            <span>{TLang('点击切换不同票价，再次点击取消选择', 'home', false, false, null)}</span>
            <img onClick={closeTipHandle} src={close} alt="" />
          </div>
        </div>
      ) : null}
    </div>
  );
};
export default memo(MulPriceArea);
